var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "TreeItem" }, [
    _c("div", { staticClass: "TreeItem_Toggle", on: { click: _vm.toggle } }, [
      _vm.isDir
        ? _c(
            "span",
            { staticClass: "TreeItem_DirIcon" },
            [
              _c("FontAwesomeIcon", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.open,
                    expression: "!open"
                  }
                ],
                attrs: { icon: "plus-square", size: "1x" }
              }),
              _vm._v(" "),
              _c("FontAwesomeIcon", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.open,
                    expression: "open"
                  }
                ],
                attrs: { icon: "minus-square", size: "1x" }
              })
            ],
            1
          )
        : _c("span", { staticClass: "TreeItem_NodeIcon" }, [_vm._v("└")]),
      _vm._v(" "),
      !_vm.callback
        ? _c(
            "a",
            {
              staticClass: "TreeItem_Title",
              class: {
                _match: !_vm.matchFilter,
                _current: _vm.isCurrentPage(_vm.treeData.rootPath)
              },
              attrs: { href: _vm.toRelative(_vm.treeData.rootPath) }
            },
            [_vm._v("\n      " + _vm._s(_vm.treeData.title) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.callback
        ? _c(
            "span",
            {
              staticClass: "TreeItem_Title",
              class: {
                _match: !_vm.matchFilter,
                _current: _vm.isCurrentPage(_vm.treeData.rootPath)
              },
              on: {
                click: function($event) {
                  _vm.onClickTreeItem(_vm.treeData.title, _vm.treeData.rootPath)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.treeData.title) + "\n    ")]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.isDir
      ? _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open"
              }
            ],
            staticClass: "TreeItem_List"
          },
          _vm._l(_vm.treeDataChildren, function(treeDataChild, index) {
            return _c("TreeItem", {
              key: index,
              staticClass: "item",
              attrs: {
                filterWord: _vm.filterWord,
                treeData: treeDataChild,
                toRoot: _vm.toRoot,
                currentPathFromRoot: _vm.currentPathFromRoot,
                callback: _vm.callback
              },
              on: {
                expand: _vm.onExpand,
                closeTreeDialog: _vm.onCloseTreeDialog
              }
            })
          })
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }